<template>
  <div class="mountain-page">
    <div class="audio-box" @click="controlMusic">
      <img
        v-show="zdAudioPlaying"
        class="audio-on"
        src="../assets/img/music_on.png"
        alt=""
      />
      <img
        v-show="!zdAudioPlaying"
        class="audio-off"
        src="../assets/img/music_off.png"
        alt=""
      />
    </div>

    <div v-show="!visitedAll" @click="hideRoad" class="back-btn" alt="">
      <img
        class="back-btn-txt abs"
        src="../assets/img/back_btn_txt.png"
        alt=""
      />
    </div>
    <img
      v-show="!visitedAll"
      @click="endVisit"
      class="end-btn"
      src="../assets/img/end_btn.png"
      alt=""
    />
    <div class="end-page abs">
      <div class="end-txt abs"></div>
      <!-- <img class="end-txt abs" src="../assets/img/end_txt_qt.png" alt="" /> -->
      <img class="end-page-bg" src="../assets/img/end_page_zd.jpg" alt="" />
    </div>

    <div class="mountain">
      <div class="progress-list-box abs">
        <img class="icon-road abs" src="../assets/img/icon_road2.png" alt="" />
        <div
          :class="[actIndex == item ? 'active' : '', 'progress-item']"
          v-for="item in 3"
          :key="item"
        ></div>
      </div>
      <!-- 天台县 -->
      <img
        class="nor-tt-moun2 abs"
        src="../assets/img/nor_tt_moun2.png"
        alt=""
      />
      <img
        class="nor-tt-moun1 abs"
        src="../assets/img/nor_tt_moun1.png"
        alt=""
      />
      <div class="moun-box-tt abs">
        <img class="data-moun-tt" src="../assets/img/data_moun_tt.png" alt="" />
        <div class="data-box-tt abs"></div>
      </div>
      <img class="address-tt abs" src="../assets/img/address_tt.png" alt="" />

      <!-- <img class="feature-tt abs" src="../assets/img/feature_tt.jpg" alt="" /> -->
      <div class="feature-tt abs">
        <img
          ref="featureTtGif"
          class="feature-data abs"
          src="../assets/img/feature_tt.gif"
          alt=""
        />
        <img
          class="feature-bg"
          style="width:100%; height: 100%;"
          src="../assets/img/feature_tt_bg.png"
          alt=""
        />
      </div>
      <!-- <div class="product-tt abs"></div> -->
      <img class="product-tt abs" src="../assets/img/product_tt.png" alt="" />
      <!-- 天台县 -->

      <!-- 三门县 -->
      <img
        class="nor-sm-moun2 abs"
        src="../assets/img/nor_sm_moun2.png"
        alt=""
      />
      <img
        class="nor-sm-moun1 abs"
        src="../assets/img/nor_sm_moun1.png"
        alt=""
      />
      <div class="moun-box-sm abs">
        <img class="data-moun-sm" src="../assets/img/data_moun_sm.png" alt="" />
        <div class="data-box-sm abs"></div>
      </div>
      <img class="address-sm abs" src="../assets/img/address_sm.png" alt="" />
      <!-- 三门县 -->

      <!-- 仙居县 -->
      <img
        class="nor-xj-moun2 abs"
        src="../assets/img/nor_xj_moun2.png"
        alt=""
      />
      <img
        class="nor-xj-moun1 abs"
        src="../assets/img/nor_xj_moun1.png"
        alt=""
      />
      <div class="moun-box-xj abs">
        <img class="data-moun-xj" src="../assets/img/data_moun_xj.png" alt="" />
        <div class="data-box-xj abs"></div>
      </div>
      <img class="icon-gdp abs" src="../assets/img/icon_gdp_xj.png" alt="" />
      <img class="address-xj abs" src="../assets/img/address_xj.png" alt="" />

      <!-- <img class="feature-xj abs" src="../assets/img/feature_xj.jpg" alt="" /> -->
      <div class="feature-xj abs">
        <img
          ref="featureXjGif"
          class="feature-data abs"
          src="../assets/img/feature_xj.gif"
          alt=""
        />
        <img
          class="feature-bg"
          style="width:100%; height: 100%;"
          src="../assets/img/feature_xj_bg.png"
          alt=""
        />
      </div>
      <img class="product-xj abs" src="../assets/img/product_xj.png" alt="" />
      <!-- 仙居县 -->
    </div>
    <div class="scroll-page" id="scrollPageZd">
      <div class="inner-scroll"></div>
    </div>

    <img ref="hand" class="hand abs" src="../assets/img/hand.png" alt="" />
    <img
      ref="handTips"
      class="hand-tips abs"
      src="../assets/img/hand_tips.png"
      alt=""
    />
    <!-- <img
      v-if="showCover"
      class="cover-zd"
      id="coverZd"
      src="../assets/img/cover_zd.jpg"
      alt=""
    /> -->
  </div>
</template>
<script>
import gsap from "gsap";
import { Howl } from "howler";
export default {
  name: "Mountain",
  props: ["visitedAll", "zdAudioPlaying"],
  data() {
    return {
      showCover: true,
      actIndex: 1
    };
  },
  created() {
    this.scrollAudio = new Howl({
      src:
        "https://hw-v.cztv.com/cztv/vod/2022/07/26/83a88af31cb145f1b6d2625b2040f7e4/mp3_64k_mp3.mp3",
      preload: true,
      autoplay: false,
      loop: false
    });
    this.featureAudio = new Howl({
      src:
        "https://hw-v.cztv.com/cztv/vod/2022/07/26/7d2da5535fab4bf39043077881ec1e36/mp3_64k_mp3.mp3",
      preload: true,
      autoplay: false,
      loop: false
    });
  },
  mounted() {
    // document.getElementById("coverZd").addEventListener("touchmove", () => {
    //   this.showCover = false;
    // });
    // let audioScroll = document.getElementById("audioScroll");

    // document
    //   .getElementById("scrollPageZd")
    //   .addEventListener("touchmove", () => {
    //     this.scrollAudio.play();
    //   });

    gsap.to(".mountain-page .hand", { y: -50, duration: 2, repeat: -1 });

    const tl = new gsap.timeline({
      paused: true
    });

    document
      .getElementById("scrollPageZd")
      .addEventListener("touchstart", () => {
        this.$refs.hand.style.display = "none";
        this.$refs.handTips.style.display = "none";
        // this.scrollAudio.play();
        gsap.to(".data-box-xj", {
          width: "100%",
          duration: 1,
          ease: "Power0.easeIn"
        });
      });

    // tl.to(".data-box-xj", { width: "100%", duration: 1, ease: "Power0.easeIn" })
    tl.from(".product-xj", {
      opacity: 0,
      width: 0,
      duration: 0.2,
      delay: 0.5,
      onStart: () => {
        this.featureAudio.play();
      }
    })
      .addLabel("xj")
      .to(".product-xj", { opacity: 0, duration: 0.2 }, "xj+=0.5")
      .to(
        ".feature-xj",
        {
          opacity: 1,
          y: -200,
          onStart: () => {
            this.$refs.featureXjGif.style.display = "block";
          }
        },
        "xj+=0.5"
      )
      .to(".feature-xj", { opacity: 0, y: -400 }, "xj+=1.4")
      .to(
        ".moun-box-xj",
        {
          x: 50,
          y: 550,
          scale: 1.7,
          duration: 1.5,
          ease: "Power0.easeIn"
        },
        "xj+=1.5"
      )
      .to(
        ".nor-xj-moun1",
        { x: -80, y: 500, scale: 1.5, duration: 2 },
        "xj+=1.5"
      )
      .to(
        ".nor-xj-moun2",
        { x: -80, y: 500, scale: 1.5, duration: 2.5 },
        "xj+=1.5"
      )
      .to(".moun-box-sm", { bottom: 0, opacity: 1, duration: 1 }, "xj+=1.5")
      .to(".nor-sm-moun1", { bottom: 0, opacity: 1, duration: 1 }, "xj+=1.5")
      .to(".nor-sm-moun2", { bottom: 0, opacity: 1, duration: 1 }, "xj+=1.5")
      .to(".data-box-xj", { opacity: 0, duration: 0.2 }, "xj+=1.55")
      .to(".moun-box-tt", { opacity: 0.1, duration: 0.5 }, "xj+=1.6")
      .to(".address-xj", { x: -50, opacity: 0, duration: 0.5 }, "xj+=2")
      .to(
        ".address-sm",
        {
          x: -50,
          opacity: 1,
          duration: 0.5,
          onStart: () => {
            this.actIndex++;
          },
          onReverseComplete: () => {
            this.actIndex--;
          },
          onComplete() {
            gsap.to(".data-box-sm", { width: "100%", duration: 1 });
          }
        },
        "xj+=2.2"
      )
      .to(
        [".moun-box-xj", ".nor-xj-moun1", ".nor-xj-moun2"],
        { opacity: 0, duration: 0.3 },
        "xj+=2.4"
      )
      // .to(".data-box-sm", { width: "100%", duration: 1 }, 3.6)
      .addLabel("sm")

      .to(".moun-box-sm", { x: 50, y: 550, scale: 1.7, duration: 1.5 }, "sm")
      .to(".nor-sm-moun1", { x: -80, y: 530, scale: 1.5, duration: 2 }, "sm")
      .to(".nor-sm-moun2", { x: -80, y: 530, scale: 1.5, duration: 2.5 }, "sm")
      .to(".moun-box-tt", { opacity: 1, duration: 0.4 }, "sm")
      .to(".moun-box-tt", { bottom: 0, duration: 1 }, "sm")
      .to(".nor-tt-moun1", { opacity: 1, duration: 0.3 }, "sm")
      .to(".nor-tt-moun2", { opacity: 1, duration: 0.3 }, "sm")
      .to(".nor-tt-moun1", { y: 50, duration: 1 }, "sm")
      .to(".nor-tt-moun2", { y: 50, duration: 1 }, "sm")
      .to(".address-sm", { x: -100, opacity: 0, duration: 0.5 }, "sm+=0.4")
      .to(
        ".address-tt",
        {
          x: -50,
          opacity: 1,
          duration: 0.5,
          onStart: () => {
            this.actIndex++;
          },
          onReverseComplete: () => {
            this.actIndex--;
          },
          onComplete() {
            gsap.to(".data-box-tt", { width: "100%", duration: 1 });
          }
        },
        "sm+=0.6"
      )
      .to(
        [".moun-box-sm", ".nor-sm-moun1", ".nor-sm-moun2"],
        { opacity: 0, duration: 0.3 },
        "sm+0.9"
      )
      // .to(".data-box-tt", { width: "100%", duration: 1 }, "sm+=1.1")
      .addLabel("tt")
      .from(
        ".product-tt",
        {
          opacity: 0,
          width: 0,
          duration: 0.2,
          onStart: () => {
            this.featureAudio.play();
          }
        },
        "tt-=0.5"
      )
      .to(".product-tt", { opacity: 0, duration: 0.2 }, "tt")
      .from(
        ".feature-tt",
        {
          opacity: 0,
          y: 200,
          onStart: () => {
            this.$refs.featureTtGif.style.display = "block";
          }
        },
        "tt"
      )
      .to(".feature-tt", { opacity: 0, y: -200 }, "tt+=0.5")
      .to(
        [".back-btn", ".end-btn"],
        { opacity: 1, duration: 2, display: "block" },
        "tt+=1"
      )
      .to(
        ".end-page",
        {
          opacity: 1,
          duration: 0.5,
          onStart: () => {
            gsap.from(".end-txt", {
              opacity: 0,
              height: 0,
              delay: 0.2,
              duration: 2,
              onComplete: () => {
                if (this.visitedAll) {
                  setTimeout(() => {
                    this.endVisit();
                  }, 2500);
                }
              }
            });
          }
        },
        "tt+=1"
      );

    // tl.play();

    let scrollPage = document.getElementById("scrollPageZd");
    let scrollHeight = scrollPage.scrollHeight;
    let progressHeight = scrollHeight - window.innerHeight;
    let progress, top;
    scrollPage.addEventListener(
      "scroll",
      function() {
        top = scrollPage.scrollTop;
        progress = parseFloat(top / progressHeight);
        // console.log(progress);
        tl.progress(progress);
      },
      false
    );
    // console.log(scrollHeight);
    // eslint-disable-next-line
    // let scroller = new Scroller(
    //   // eslint-disable-next-line
    //   (left, top, zoom) => {
    //     // this.currScrollLeft = left;
    //     // top = parseInt(top);
    //     let progress = top / progressHeight;
    //     tl.progress(progress);
    //   },
    //   {
    //     zooming: true,
    //     bouncing: false,
    //     scrollingX: false,
    //     scrollingY: true
    //   }
    // );
    // scroller.setDimensions(
    //   window.innerWidth,
    //   window.innerHeight,
    //   window.innerWidth,
    //   scrollHeight
    // );
    // let mousedown = false;
    // scrollPage.addEventListener(
    //   "touchstart",
    //   e => {
    //     scroller.doTouchStart(e.touches, e.timeStamp);
    //     mousedown = true;
    //   },
    //   false
    // );
    // scrollPage.addEventListener(
    //   "touchmove",
    //   e => {
    //     if (!mousedown) {
    //       return;
    //     }
    //     scroller.doTouchMove(e.touches, e.timeStamp);
    //     mousedown = true;
    //   },
    //   false
    // );
    // scrollPage.addEventListener(
    //   "touchend",
    //   e => {
    //     if (!mousedown) {
    //       return;
    //     }
    //     scroller.doTouchEnd(e.timeStamp);
    //     mousedown = false;
    //   },
    //   false
    // );
  },
  methods: {
    hideRoad() {
      this.$emit("hideroad", "zd");
    },
    endVisit() {
      this.$emit("endvisit", "zd");
    },
    controlMusic() {
      this.$emit("playmusic", "zd");
    }
  }
};
</script>
<style lang="less" scoped>
.mountain-page {
  width: 100%;
  height: 100%;
  background-color: #fff;
  // background: url("../assets/img/bg.jpg") no-repeat center;
  // background-size: 100% 100%;
  .hand {
    width: 89px;
    height: 90px;
    left: 50%;
    margin-left: -20px;
    bottom: 120px;
    z-index: 5;
  }
  .hand-tips {
    width: 191px;
    height: 58px;
    left: 50%;
    margin-left: -80px;
    bottom: 80px;
    z-index: 5;
  }
  .back-btn {
    background-color: rgba(36, 131, 171, 0.75);
  }
  .end-page {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    z-index: 5;
    .end-txt {
      width: 539px;
      height: 282px;
      top: 102px;
      left: 50%;
      margin-left: -539/2px;
      background: url("../assets/img/end_txt_zd.png") no-repeat top;
      background-size: 100% auto;
    }
    .end-page-bg {
      width: 100%;
      height: 100%;
    }
  }
  .progress-list-box {
    top: 100px;
    right: 60px;
    z-index: 2;
    .icon-road {
      width: 63px;
      height: 64px;
      top: -64 - 23px;
      left: -21px;
    }
    .progress-item {
      width: 0;
      height: 0;
      border: 8px solid transparent;
      border-bottom: 16px solid rgba(26, 167, 193, 0.25);
      margin-bottom: 7px;
      &.active {
        border-bottom: 16px solid #1aa7c1;
        // background-color: #4890b9;
      }
    }
  }
  .mountain {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    .product-xj {
      width: 577px;
      height: 635px;
      top: 86/1334 * 100%;
      left: 50%;
      // margin-top: -635/2 - 50px;
      // margin-left: -577/2px;
      transform: translateX(-50%);
      // opacity: 0;
      z-index: 5;
    }
    .feature-xj {
      width: 710px;
      height: 842px;
      left: 50%;
      margin-left: -355px;
      top: 500px;
      opacity: 0;
      z-index: 10;
      box-shadow: 5px 5px 50px rgba(0, 0, 0, 0.2);
      z-index: 10;
      .feature-data {
        width: 615px;
        height: 367px;
        top: 240px;
        left: 40px;
        display: none;
      }
    }
    .address-xj {
      width: 105px;
      height: 356px;
      left: 27px;
      top: 25px;
    }
    .icon-gdp {
      width: 172px;
      height: 24px;
      left: 39px;
      bottom: 837px;
    }
    .moun-box-xj {
      width: 750px;
      height: 791px;
      right: 0;
      bottom: 0;
      .data-box-xj {
        width: 0;
        height: 743px;
        left: 23px;
        top: -32px;
        background: url("../assets/img/data_xj.png") no-repeat left top;
        background-size: auto 100%;
        z-index: 5;
      }
      .data-moun-xj {
        width: 100%;
        height: 100%;
      }
    }
    .nor-xj-moun1 {
      width: 750px;
      height: 712px;
      left: 0;
      bottom: 0;
    }
    .nor-xj-moun2 {
      width: 750px;
      height: 909px;
      left: 0;
      bottom: 0;
    }
    .address-sm {
      width: 108px;
      height: 352px;
      top: 25px;
      left: 27px + 108px;
      opacity: 0;
    }
    .moun-box-sm {
      width: 750px;
      height: 787px;
      left: 0;
      bottom: 160px;
      opacity: 0.1;
      .data-moun-sm {
        width: 100%;
        height: 100%;
      }
      .data-box-sm {
        width: 0;
        height: 725px;
        top: -17px;
        left: 24px;
        background: url("../assets/img/data_sm.png") no-repeat left;
        background-size: auto 100%;
      }
    }
    .nor-sm-moun1 {
      width: 750px;
      height: 769px;
      bottom: 80px;
      left: 0;
      opacity: 0;
    }
    .nor-sm-moun2 {
      width: 750px;
      height: 900px;
      bottom: 80px;
      left: 0;
      opacity: 0;
    }
    .product-tt {
      width: 577px;
      height: 565px;
      top: 86/1334 * 100%;
      left: 50%;
      // margin-top: -565/2 - 50px;
      // margin-left: -577/2px;
      transform: translateX(-50%);
      // opacity: 0;
      // background: url("../assets/img/product_tt.png") no-repeat top center;
      // background-size: auto 100%;
      z-index: 5;
    }
    .feature-tt {
      width: 710px;
      height: 887px;
      top: 86/1334 * 100%;
      left: 50%;
      margin-left: -355px;
      // opacity: 0;
      z-index: 10;
      box-shadow: 5px 5px 50px rgba(0, 0, 0, 0.2);
      .feature-data {
        width: 644px;
        height: 590px;
        top: 213px;
        left: 20px;
        display: none;
      }
    }
    .address-tt {
      width: 105px;
      height: 356px;
      top: 25px;
      left: 27px + 108px;
      opacity: 0;
    }
    .moun-box-tt {
      width: 750px;
      height: 807px;
      left: 0;
      bottom: 150px;
      opacity: 0;
      .data-moun-tt {
        width: 100%;
        height: 100%;
      }
      .data-box-tt {
        width: 0;
        height: 762px;
        top: -35px;
        left: 20px;
        background: url("../assets/img/data_tt.png") no-repeat left;
        background-size: auto 100%;
      }
    }
    .nor-tt-moun1 {
      width: 750px;
      height: 571px;
      left: 0;
      bottom: 418px;
      opacity: 0;
    }
    .nor-tt-moun2 {
      width: 750px;
      height: 741px;
      right: 0;
      bottom: 340px;
      opacity: 0;
    }
  }
  .scroll-page {
    position: absolute;
    z-index: 10;
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
    .inner-scroll {
      width: 100%;
      height: 16000px;
    }
  }
}
@keyframes dataAni {
  from {
    width: 0%;
  }
  to {
    width: 100%;
  }
}
</style>
